import { Component, input } from '@angular/core';
import { OnyxIconComponent } from '@onyx/angular';
import { FleetIdentifierPipe } from '../../../../../../common/pipes/fleet-identifier.pipe';
import type { Fleet } from '../../../../../fleet/common/interfaces/fleet';

@Component({
  selector: 'app-base-vehicle-cell',
  imports: [OnyxIconComponent, FleetIdentifierPipe],
  templateUrl: './base-vehicle-cell.component.html',
  styleUrl: './base-vehicle-cell.component.scss',
})
export class BaseVehicleCellComponent {
  public readonly generalInformation = input.required<
    Fleet['generalInformation'] | null
  >();
}
